import React from "react";
import ProjectsTableEVSPI from "../../components/projects/dashboard/ProjectsTableEVSPI";
import { useNavigate } from "react-router-dom";
import WeeklyProgressAll from "../../components/projects/dashboard/WeeklyProgressAll";
import TaskStatusAll from "../../components/projects/dashboard/TaskStatusAll";
import RiskHeatmapAll from "../../components/projects/dashboard/RiskHeatmapAll";

// Project Management Dashboard (React 19 friendly)
// - Pure TailwindCSS UI (no external UI libs)
// - Uses React 19 head metadata (title/meta inside component)
// - Replace mocked data/fetch with your API hooks later

export default function AllProjectsDashboard() {
  // ---- Mocked summary data ----
  const kpis = [
    { label: "Active Projects", value: 7, sub: "+2 this month" },
    { label: "Open Tasks", value: 124, sub: "23 overdue" },
    { label: "This Week Progress", value: "42%", sub: "avg across projects" },
    { label: "Risks", value: 5, sub: "2 high, 3 medium" },
  ];

  const projects = [
    { id: "PRJ-001", name: "Biomass Conveyor Revamp", owner: "Mitsui Miike", progress: 0.68, evPercent: 63.2, pvPercent: 68.7, due: "2025-11-15" },
    { id: "PRJ-014", name: "WBS Suite Rollout", owner: "Internal", progress: 0.33, evPercent: 63.2, pvPercent: 68.7, due: "2025-12-30" },
    { id: "PRJ-022", name: "Smart Traffic Pilot", owner: "Gangwon Province", progress: 0.52, evPercent: 63.2, pvPercent: 68.7, due: "2026-02-10" },
  ];

  const activities = [
    { at: "2025-09-26 09:40", who: "Kyoungil Kim", what: "Approved WBS update for PRJ-001 (Pkg. B)" },
    { at: "2025-09-26 08:10", who: "Hirao", what: "Submitted actuals: PRJ-001 / Conveyor Erection 18% → 24%" },
    { at: "2025-09-25 17:25", who: "PMO Bot", what: "2 tasks overdue in PRJ-014: QA checklist, Stakeholder email" },
  ];


  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gray-50 w-full">
      {/* React 19 head metadata */}
      <title>프로젝트 대시보드 - Project Management</title>
      <meta name="description" content="WBS·작업·리스크·일정 현황을 한눈에 보는 프로젝트 Management 대시보드" />
      <meta property="og:title" content="Project Management Dashboard" />
      <meta property="og:type" content="website" />

      {/* Header */}
      <header className="sticky top-0 z-10 bg-white/80 backdrop-blur border-b">
        <div className="mx-auto max-w-[1100px] px-6 py-4 flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="w-9 h-9 rounded-2xl bg-gray-900" />
            <div>
              <h1 className="text-lg font-semibold">Project Management</h1>
              <p className="text-xs text-gray-500">Dashboard</p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <input className="hidden md:block w-64 text-sm rounded-xl border px-3 py-2 focus:outline-none focus:ring-2 focus:ring-gray-300" placeholder="Search projects, tasks…" />
            <button className="rounded-xl border px-3 py-2 text-sm hover:bg-gray-50">New Project</button>
          </div>
        </div>
      </header>

      {/* Body */}
      <main className="mx-auto max-w-[1100px] px-6 py-6 space-y-6">
        {/* KPI cards */}
        <section className="grid grid-cols-2 md:grid-cols-4 gap-4">
          {kpis.map((k) => (
            <div key={k.label} className="rounded-2xl border bg-white p-4">
              <p className="text-xs text-gray-500">{k.label}</p>
              <p className="mt-2 text-2xl font-semibold">{k.value}</p>
              <p className="mt-1 text-xs text-gray-400">{k.sub}</p>
            </div>
          ))}
        </section>

        {/* Charts row (placeholders) */}
        <section className="grid grid-cols-1 lg:grid-cols-3 gap-4">
          <WeeklyProgressAll />
          <TaskStatusAll />
          <RiskHeatmapAll />
        </section>

        {/* Projects table */}
        <ProjectsTableEVSPI
          title="Active Projects"
          projects={projects}
          onOpen={(p) => navigate(`/projects/${p.id}`)}
          onViewAll={() => navigate('/projects')}
        />
        {/* <section className="rounded-2xl border bg-white">
          <div className="px-4 py-3 border-b flex items-center justify-between">
          <h2 className="text-sm font-medium">Active Projects</h2>
          <button className="text-xs rounded-lg border px-2.5 py-1 hover:bg-gray-50">View all</button>
          </div>
          <div className="overflow-x-auto">
          <table className="min-w-full text-sm">
          <thead>
          <tr className="text-left text-gray-500">
          <th className="px-4 py-2">ID</th>
          <th className="px-4 py-2">Name</th>
          <th className="px-4 py-2">Owner</th>
          <th className="px-4 py-2">Progress</th>
          <th className="px-4 py-2">Due</th>
          <th className="px-4 py-2"></th>
          </tr>
          </thead>
          <tbody>
          {projects.map(p => (
            <tr key={p.id} className="border-t">
            <td className="px-4 py-3 font-mono text-xs">{p.id}</td>
            <td className="px-4 py-3 font-medium">{p.name}</td>
            <td className="px-4 py-3">{p.owner}</td>
            <td className="px-4 py-3">
            <div className="w-44 h-2 rounded-full bg-gray-200">
            <div className="h-2 rounded-full bg-gray-900" style={{ width: `${p.progress * 100}%` }} />
            </div>
            <span className="ml-2 align-middle text-xs text-gray-500">{Math.round(p.progress * 100)}%</span>
            </td>
            <td className="px-4 py-3 text-gray-600">{p.due}</td>
            <td className="px-4 py-3">
            <button className="text-xs rounded-lg border px-2.5 py-1 hover:bg-gray-50">Open</button>
            </td>
            </tr>
            ))}
            </tbody>
            </table>
            </div>
            </section> */}


        {/* Activity & My tasks */}
        <section className="grid grid-cols-1 lg:grid-cols-2 gap-4">
          <div className="rounded-2xl border bg-white p-4">
            <h2 className="text-sm font-medium">Recent Activity</h2>
            <ul className="mt-3 space-y-3">
              {activities.map((a, idx) => (
                <li key={idx} className="flex items-start gap-3">
                  <div className="mt-1 w-2 h-2 rounded-full bg-gray-900" />
                  <div>
                    <p className="text-sm">{a.what}</p>
                    <p className="text-xs text-gray-500">{a.who} · {a.at}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="rounded-2xl border bg-white p-4">
            <h2 className="text-sm font-medium">My Tasks</h2>
            <ul className="mt-3 space-y-2">
              {[{t:"Submit WBS for Package C", d:"Today 17:00"}, {t:"Review Risk Register", d:"Tomorrow"}, {t:"Email Project Overview", d:"Fri"}].map((t, i) => (
                <li key={i} className="flex items-center justify-between rounded-xl border px-3 py-2">
                  <span className="text-sm">{t.t}</span>
                  <span className="text-xs text-gray-500">{t.d}</span>
                </li>
              ))}
            </ul>
          </div>
        </section>
      </main>
    </div>
  );
}
